export default "__VITE_ASSET__C1BGb5$2__"